import React, { useState } from 'react';

const Leerfahrten = () => {
  const [form, setForm] = useState({
    fahrzeug: '',
    routeVon: '',
    routeNach: '',
    datum: '',
    kapazitaet: '',
    preis: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Leerfahrt "${form.fahrzeug}" eingetragen!`);
    // später: fetch() ans Backend + Bezahl-Check
  };

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Leerfahrt anbieten (Unternehmer)</h1>
      <p className="mb-6 text-sm text-gray-600 dark:text-slate-400">
        Hinweis: Unternehmer müssen für das Einstellen von Leerfahrten zahlen. Preise & Zahlungsoptionen siehe <a href="/pricing" className="text-blue-600">Preise</a>.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="fahrzeug"
          value={form.fahrzeug}
          onChange={handleChange}
          placeholder="Fahrzeugtyp"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
          required
        />
        <input
          type="text"
          name="routeVon"
          value={form.routeVon}
          onChange={handleChange}
          placeholder="Von"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
          required
        />
        <input
          type="text"
          name="routeNach"
          value={form.routeNach}
          onChange={handleChange}
          placeholder="Nach"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
          required
        />
        <input
          type="date"
          name="datum"
          value={form.datum}
          onChange={handleChange}
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
          required
        />
        <input
          type="text"
          name="kapazitaet"
          value={form.kapazitaet}
          onChange={handleChange}
          placeholder="Kapazität (z.B. 12 Paletten)"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
        />
        <input
          type="text"
          name="preis"
          value={form.preis}
          onChange={handleChange}
          placeholder="Preisvorstellung"
          className="w-full p-3 rounded border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-slate-900 dark:text-slate-100"
        />

        <button
          type="submit"
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-bold transition"
        >
          Leerfahrt eintragen
        </button>
      </form>
    </div>
  );
};

export default Leerfahrten;
